import { useState } from 'react'

import { BsFillXSquareFill } from 'react-icons/bs'

import { useParams } from 'react-router-dom'

import { useProcessContactAddress } from '../../../../../hooks/fetch/contactAddress/useProcessContactAddress'
import useContactAddInfo from '../../../../../hooks/useContactAddInfo'
import useContactAddressShared from '../../../../../hooks/useContactAddressShared'
import useContactBasicInfo from '../../../../../hooks/useContactBasicInfo'
import useContactSiteInfo from '../../../../../hooks/useContactSiteInfo'
import useEditContact from '../../../../../hooks/useEditContact'

import EditContactAddInfo from './EditContactAddInfo/EditContactAddInfo'
import EditContactBasic from './EditContactBasic/EditContactBasic'
import EditContactSiteInfo from './EditContactSiteInfo/EditContactSiteInfo'
import { useQueryContactAddress } from '../../../../../hooks/fetch/contactAddress/useQueryContactAddress'
import { ContactAddressType } from '../../../../../common/ContactAddress.type'

import { validateContactForm } from '../../../../../util/validateContactForm'

const EditContact = () => {
  const [isShowAddInfo, setIsShowAddInfo] = useState(false)
  const [isShowSiteInfo, setIsShowSiteInfo] = useState(false)

  const { id } = useParams()
  const { data: contactAddresses, isError } = useQueryContactAddress()
  // console.log(`EditContact() id=${id}`)
  // console.log(`EditContact() isError=${isError}`)
  // console.log(`EditContact() contactAddresses=${JSON.stringify(contactAddresses)}`)

  let currContactAddress = {} as ContactAddressType
  if (!isError && contactAddresses) {
    currContactAddress = contactAddresses.filter(
      (contactAddress) => contactAddress.id.toString() === (id as string)
    )[0]
  }
  else {
    currContactAddress = {} as ContactAddressType
  }
  // console.log(`EditContact() currContactAddress=${JSON.stringify(currContactAddress)}`)

  const { editContact, navigatePrevPage } = useEditContact()

  const editContactBasic = useContactBasicInfo(currContactAddress)
  const editContactAdd = useContactAddInfo(currContactAddress)
  const editContactSite = useContactSiteInfo(currContactAddress)
  const { category } = useContactAddressShared(currContactAddress.category)
  // console.log(`EditContact() editContactBasic=${JSON.stringify(editContactBasic)}`)
  // console.log(`EditContact() editContactAdd=${JSON.stringify(editContactAdd)}`)
  // console.log(`EditContact() editContactSite=${JSON.stringify(editContactSite)}`)
  // console.log(`EditContact() category=${category}`)

  const { lastName } = editContactBasic.state

  const allState = {
    ...editContactBasic.state,
    ...editContactAdd.address.state,
    ...editContactAdd.other.state,
    ...editContactSite.state,
    category,
  }
  const editedContactAddress = {
  ...allState,
  id,
  isFavorite: false,
  contactName: allState.lastName + allState.firstName,
  contactType: currContactAddress.contactType,

  externalNumbers: allState.externalNumbers
    .filter((row) => row.externalPhoneNumber.trim() !== '')
    .map((row, idx) => {
      const isEmptyLabel =
        row.labelCode == null ||
        row.labelCode === 9 ||
        (row.labelCode === 99 && (row.customLabel ?? '').trim() === '')

      return {
        ...row,
        labelCode: isEmptyLabel ? 9 : row.labelCode,
        customLabel: isEmptyLabel ? '' : row.customLabel,
        displayOrder: row.displayOrder ?? idx + 1,
      }
    }),
}


  const { updateContactAddress } = useProcessContactAddress()

  return (
    <div className="box inner-box stack">
      <span className="cursor-pointer upper-right" onClick={navigatePrevPage}>
        <BsFillXSquareFill size={'1rem'} />
      </span>

      <EditContactBasic {...editContactBasic} />

      <div className="mt-5">
        <h6>
          <span
            className="cursor-pointer"
            onClick={() => setIsShowAddInfo((prev) => !prev)}
          >
            {isShowAddInfo ? '▾' : '▸'}その他の項目
          </span>
        </h6>
        <hr />
      </div>

      {isShowAddInfo ? <EditContactAddInfo {...editContactAdd} /> : <p></p>}

      <div className="mt-5">
        <h6>
          <span
            className="cursor-pointer"
            onClick={() => setIsShowSiteInfo((prev) => !prev)}
          >
            {isShowSiteInfo ? '▾' : '▸'}Webサイト/SNS情報
          </span>
        </h6>
      </div>
      <hr />
      {isShowSiteInfo ? (
        <EditContactSiteInfo {...editContactSite} />
      ) : (
        <div className="switcher">
          <p></p>
        </div>
      )}

      <hr />

      <div className="switcher">
        <button
          type="button"
          className="submitButton"
          onClick={(e) => {

            const errorMsg = validateContactForm(
              editedContactAddress as unknown as Record<string, string | boolean>
            )

            if (errorMsg) {
              alert(errorMsg)
              return
            }
            editContact({
              ...allState,
              id: currContactAddress.id,
              isFavorite: false,
              createdDate: `約${(new Date().getMonth() + 1).toString()}ヶ月前`,
            })

            updateContactAddress(e, editedContactAddress)
          }}
          disabled={lastName.length === 0}
        >
          連絡先を保存
        </button>

        <button
          type="button"
          className="submitButton btn-danger ms-3"
          onClick={navigatePrevPage}
        >
          キャンセル
        </button>
      </div>
    </div>
  )
}

export default EditContact
